<app-page headline="Users">
  <DataTable
    [datasource]="users"
    [columns]="usersColumns"
    height="calc(100vh - 300px)"
    (rowClick)="handleRowClick($event)"
  >
    <div
      row-layout
      paddingLeft="md"
      ngProjectAs="data-table-header"
      justifyContent="space-between"
      alignItems="center"
    >
      <div row-layout alignItems="center" gap="md">
        <Text role="headline-small">Users List</Text>

        <Tooltip label="Add User" placement="right">
          <button
            icon-button
            symbolName="person_add"
            [routerLink]="['/user-management/create-user']"
            size="md"
          >
            Add User
          </button>
        </Tooltip>

        <app-download-button
          label="Download Users"
          [blobObservable]="downloadUsers()"
          [downloadFileName]="getUsersDownloadFilename()"
          [preserveFileExtension]="true"
          [preferFileNameFromHeader]="false"
        ></app-download-button>

        <button
          text-button
          variant="primary"
          size="md"
          (click)="syncUsers()"
          [loading]="isSyncingUsers()"
          [disabled]="isSyncingUsers()"
        >
          Sync
        </button>
      </div>

      <div row-layout alignItems="center" gap="sm">
        <app-input
          [form]="searchForm"
          controlName="search"
          [placeholder]="'Search'"
          (keyup.enter)="canSearch() && searchUsers()"
        />
        <button
          text-button
          variant="primary"
          size="md"
          (click)="searchUsers()"
          [disable]="!canSearch()"
          [loading]="users.isLoading()"
        >
          Search
        </button>
        @if ((searchForm.controls.search.value || '').trim().length > 0) {
          <Tooltip label="Reset Search" placement="top">
            <button
              text-button
              variant="ghost"
              size="md"
              (click)="resetSearch()"
            >
              Reset
            </button>
          </Tooltip>
        }
      </div>
    </div>

    <div ngProjectAs="data-table-footer" stack-layout gap="md">
      <div grid-layout>
        <div row-layout justifyContent="space-between">
          <Text>{{ users.recordCount() }} Users Found</Text>
          <oui-paginator [datasource]="users" [initPageSize]="15" />
          <div></div>
        </div>
      </div>
    </div>
  </DataTable>
</app-page>
